import { AppData } from '@app-interfaces';
import { STANDARD_FOUR_TIME_ZONE_ID, TIMEZONE_MAP, UtilityService } from '@eforall/common';
import { FuncData, StandardFourTimeZoneId } from '@interfaces';



/**
 * Convert func data into structures that can more
 * easily be used in the app (e.g. compound objects)
  */
export function processData(data: FuncData, util: UtilityService): AppData {

	//
	// Return all the data
	//
	return {
		asOfUtc: data.asOfUtc,
		user: data.user,
		staff: data.staff,
		permissions: data.permissions,
		trimesters: data.trimesters.sort((a, b) => a.admissionsEndUTC - b.admissionsEndUTC),
		standardLocalTimezoneId: Number(Object.entries(TIMEZONE_MAP).find(([key, value]) => value === util.date.getTimezone())?.[0] ?? STANDARD_FOUR_TIME_ZONE_ID.Eastern) as StandardFourTimeZoneId
	};
}
